var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "card-header-element-wrapper"
  }, [_c('h5', [_c('strong', [_vm._v("Existing members")])]), _c('a-button', {
    attrs: {
      "type": "primary",
      "disabled": ""
    }
  }, [_vm._v("Upload new MRF version")])], 1)]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataSource,
      "pagination": {
        pageSize: 50
      },
      "row-key": function rowKey(record) {
        return record.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-space', {
          attrs: {
            "space": 16
          }
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "Are you sure you want to delete this member?",
            "ok-text": "Yes",
            "cancel-text": "No"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.deleteMember(record.id);
            }
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-trash font-size-15 align-middle text-gray-6",
          attrs: {
            "title": "Delete"
          }
        })])])], 1)], 1);
      }
    }, {
      key: "active",
      fn: function fn(text) {
        return _c('span', {}, [_c('a-tag', {
          attrs: {
            "color": text === 0 ? 'volcano' : 'green'
          }
        }, [_vm._v(" " + _vm._s(text === 0 ? 'INACTIVE' : 'ACTIVE') + " ")])], 1);
      }
    }])
  })], 1)])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('strong', [_vm._v("Add new member")])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('a-form-item', {
    attrs: {
      "label": "EPEX Short Name"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: _vm.epexName,
      callback: function callback($$v) {
        _vm.epexName = $$v;
      },
      expression: "epexName"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "EIC Code"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: _vm.eicCode,
      callback: function callback($$v) {
        _vm.eicCode = $$v;
      },
      expression: "eicCode"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": _vm.createMember
    }
  }, [_c('i', {
    staticClass: "fe fe-plus-circle font-size-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Add participant"
    }
  }), _vm._v(" Add member ")])], 1)], 1)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }